export class DelegationUo {
  Uos: Uo[];
  uoSelected: Uo[];
  delegates: Delegate[];

}

export class Uo {
  code: string;
  level: string;
  name: string;
  id: string;
  isClick: boolean;
}


export class Delegate {
  matricule: string;
  fullName: string;
  job: string;

  uoSelected: Uo[] = [];
  validationInjectionMasseChecked: boolean;
  selectAllUo: boolean = false;
  unlockingPlugChecked: boolean;
  fileValidationChecked: boolean;
  reopenFileChecked: boolean;
  validationInjectionSingleChecked: boolean;

  isClick: boolean;
  isClickUO: boolean = false;
  startDate: Date;
  endDate: Date;
  uoAndUsers:any;
}



// WEBPACK FOOTER //
// ./src/app/model/delegationUo.ts